import ReactDOM from 'react-dom/client'
import './index.css'
import SixGuysRP, { ErrorBoundary } from './SixGuysRP.jsx'
import UpdatePill from './UpdatePill.jsx'
import { ThemeProvider } from './ThemeContext.jsx'
import DesignShowcase from './DesignShowcase.jsx'
import { registerServiceWorker } from './pushUtils.js'
import { loadAndRegisterCustomCharacters, armCustomCharacterLoaderOnAuth } from './customCharacters.js'

// The boot guard in index.html re-requests the page if this module graph
// never runs (a stale page pointing at deleted chunks); announcing the boot
// tells it everything is fine and resets its counter.
try { window.__mfmlBootOk?.(); } catch { /* guard absent */ }

// /design — the living style page (no data, no auth): the shared vocabulary
// rendered from the live tokens so a visual refresh can be judged.
const isDesignPage = (() => { try { return window.location.pathname === '/design'; } catch { return false; } })();

ReactDOM.createRoot(document.getElementById('root')).render(
  // UpdatePill sits OUTSIDE the ErrorBoundary on purpose. Inside it, a crash
  // unmounted the pill along with everything else — so on the one screen where
  // "please refresh" matters most, the notice could never appear. The version
  // poll is a module-scope IIFE and keeps running through a crash, so the
  // event still fires; this makes sure something is still listening.
  <ThemeProvider>
    {isDesignPage ? <DesignShowcase /> : (
      <ErrorBoundary>
        <SixGuysRP />
      </ErrorBoundary>
    )}
    <UpdatePill />
  </ThemeProvider>,
)

// Register service worker for push notifications
registerServiceWorker()

// Characters created in the app (character_overrides rows with no entry in
// characters.js) are appended to the roster so every surface that imports
// CHARACTERS sees them. Fire-and-forget rather than awaited: a character
// created in the editor is registered there immediately, and blocking first
// paint on a network round-trip to show a cast that is usually empty would be
// the wrong trade. Failures log loudly — see customCharacters.js.
//
// TWO calls on purpose. The immediate one covers the no-RLS dev case and
// costs nothing; the auth-armed one is the load that actually works in
// production, because character_overrides' SELECT policy is authenticated-
// only and this module runs before the session restores — the immediate
// query is `anon` and RLS silently hands it zero rows (Vale, 2026-08-20).
loadAndRegisterCustomCharacters()
armCustomCharacterLoaderOnAuth()
